module.exports = __webpack_public_path__ + "img/dispozicia_podielom.19e13637.svg";